import { useEffect, useState } from 'react';
import RenderPreviewModal from './RenderPreviewModal';
const actionButtonClass =
  'flex flex-row items-center justify-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 transition-colors hover:border-primary-300 hover:bg-primary-500 hover:text-primary-300 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-gray-200 disabled:hover:bg-white disabled:hover:text-primary-300';

const METADATA_ROWS = [
  { label: 'Project name', key: 'projectName' },
  { label: 'Render History ID', key: 'renderHistoryId' },
  { label: 'Camera Preset', key: 'cameraPreset' },
  { label: 'Flythrough ROI', key: 'flythroughRoi' },
  { label: 'Resolution', key: 'resolution' },
  { label: 'Duration', key: 'duration' },
];

function PlayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <polygon points="8 5 19 12 8 19 8 5" />
    </svg>
  );
}

function PreviewButtonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className="shrink-0"
      aria-hidden
    >
      <path
        d="M15.75 9C15.75 9.88642 15.5754 10.7642 15.2362 11.5831C14.897 12.4021 14.3998 13.1462 13.773 13.773C13.1462 14.3998 12.4021 14.897 11.5831 15.2362C10.7642 15.5754 9.88642 15.75 9 15.75C8.11358 15.75 7.23583 15.5754 6.41689 15.2362C5.59794 14.897 4.85382 14.3998 4.22703 13.773C3.60023 13.1462 3.10303 12.4021 2.76381 11.5831C2.42459 10.7642 2.25 9.88642 2.25 9C2.25 7.20979 2.96116 5.4929 4.22703 4.22703C5.4929 2.96116 7.20979 2.25 9 2.25C10.7902 2.25 12.5071 2.96116 13.773 4.22703C15.0388 5.4929 15.75 7.20979 15.75 9Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9315 8.03228C10.4355 8.44253 10.6875 8.64803 10.6875 8.99978C10.6875 9.35153 10.4355 9.55703 9.9315 9.96728C9.79275 10.0813 9.654 10.1885 9.528 10.277C9.40811 10.3605 9.28555 10.44 9.1605 10.5155C8.658 10.8208 8.406 10.9738 8.181 10.8043C7.956 10.6348 7.935 10.2815 7.89375 9.57278C7.88229 9.38199 7.87603 9.19091 7.875 8.99978C7.875 8.82353 7.8825 8.62703 7.89375 8.42678C7.935 7.71803 7.95525 7.36403 8.181 7.19528C8.406 7.02578 8.658 7.17878 9.1605 7.48403C9.291 7.56353 9.41625 7.64453 9.528 7.72253C9.65475 7.81103 9.79275 7.91828 9.9315 8.03153"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ThumbnailButtonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className="shrink-0"
      aria-hidden
    >
      <path
        d="M11.25 5.8125C11.4986 5.8125 11.7371 5.91127 11.9129 6.08709C12.0887 6.2629 12.1875 6.50136 12.1875 6.75C12.1875 6.99864 12.0887 7.2371 11.9129 7.41291C11.7371 7.58873 11.4986 7.6875 11.25 7.6875C11.0014 7.6875 10.7629 7.58873 10.5871 7.41291C10.4113 7.2371 10.3125 6.99864 10.3125 6.75C10.3125 6.50136 10.4113 6.2629 10.5871 6.08709C10.7629 5.91127 11.0014 5.8125 11.25 5.8125Z"
        fill="currentColor"
      />
      <path
        d="M9.915 15.12C10.23 10.8698 7.14 7.33875 3.045 7.3125C2.8935 7.84875 2.8125 8.415 2.8125 9C2.81242 9.88995 3.00432 10.7694 3.37511 11.5785C3.74589 12.3875 4.28683 13.107 4.96101 13.6879C5.6352 14.2689 6.42677 14.6975 7.28171 14.9447C8.13665 15.1918 9.03484 15.2516 9.915 15.12ZM3.48 6.201C4.2645 6.246 5.01225 6.402 5.7105 6.65325C6.90525 5.84175 7.68975 4.48875 7.6875 2.952C6.78902 3.14737 5.9453 3.54029 5.21755 4.10226C4.48979 4.66423 3.89626 5.38114 3.48 6.201ZM9 1.6875C13.0388 1.6875 16.3125 4.96125 16.3125 9C16.3125 13.0388 13.0388 16.3125 9 16.3125C4.96125 16.3125 1.6875 13.0387 1.6875 9C1.6875 4.96125 4.96125 1.6875 9 1.6875ZM11.25 4.6875C10.9791 4.6875 10.711 4.74085 10.4607 4.8445C10.2105 4.94815 9.98311 5.10007 9.79159 5.29159C9.60007 5.48311 9.44815 5.71048 9.3445 5.96072C9.24085 6.21095 9.1875 6.47915 9.1875 6.75C9.1875 7.02085 9.24085 7.28905 9.3445 7.53929C9.44815 7.78952 9.60007 8.01689 9.79159 8.20841C9.98311 8.39993 10.2105 8.55185 10.4607 8.6555C10.7109 8.75915 10.9791 8.8125 11.25 8.8125C11.797 8.8125 12.3216 8.5952 12.7084 8.20841C13.0952 7.82161 13.3125 7.29701 13.3125 6.75C13.3125 6.20299 13.0952 5.67839 12.7084 5.29159C12.3216 4.9048 11.797 4.6875 11.25 4.6875ZM11.25 5.8125C11.4986 5.8125 11.7371 5.91127 11.9129 6.08709C12.0887 6.2629 12.1875 6.50136 12.1875 6.75C12.1875 6.99864 12.0887 7.2371 11.9129 7.41291C11.7371 7.58873 11.4986 7.6875 11.25 7.6875C11.0014 7.6875 10.7629 7.58873 10.5871 7.41291C10.4113 7.2371 10.3125 6.99864 10.3125 6.75C10.3125 6.50136 10.4113 6.2629 10.5871 6.08709C10.7629 5.91127 11.0014 5.8125 11.25 5.8125Z"
        fill="currentColor"
      />
    </svg>
  );
}

function ImagePlaceholderIcon({ className = 'h-10 w-10' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="8.5" cy="10.5" r="1.5" />
      <path d="M21 16l-5.2-5.2a1.5 1.5 0 0 0-2.1 0L7 17" />
    </svg>
  );
}

function PreviewLoadingOverlay({ label = '' }) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center rounded-2xl bg-white/60 backdrop-blur-[1px]">
      <svg
        className="h-8 w-8 animate-spin text-primary-300"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {label ? (
        <span className="mt-2 text-xs font-medium capitalize text-primary-300">{label}</span>
      ) : null}
    </div>
  );
}

function PreviewMediaCard({
  label,
  src = '',
  variant = 'video',
  videoFallbackSrc = '',
  onPlay,
  className = '',
  loading = false,
  loadingLabel = '',
}) {
  const imageSrc = src?.trim() ?? '';
  const fallbackVideoSrc = videoFallbackSrc?.trim() ?? '';
  const hasMedia = Boolean(imageSrc || fallbackVideoSrc) && !loading;
  const isVideo = variant === 'video';

  return (
    <div className={className}>
      <div className="relative flex h-[120px] items-center justify-center overflow-hidden rounded-2xl border border-gray-200 bg-white p-2 shadow-sm">
        {hasMedia ? (
          <>
            {isVideo ? (
              <video
                src={imageSrc || fallbackVideoSrc}
                className="max-h-full max-w-full rounded-lg object-contain"
                muted
                playsInline
                preload="metadata"
              />
            ) : imageSrc ? (
              <img
                src={imageSrc}
                alt={label}
                className="max-h-full max-w-full rounded-lg object-contain"
                draggable={false}
                referrerPolicy="no-referrer"
              />
            ) : (
              <video
                src={fallbackVideoSrc}
                className="max-h-full max-w-full rounded-lg object-contain"
                muted
                playsInline
                preload="metadata"
              />
            )}
            {isVideo ? (
              <button
                type="button"
                onClick={onPlay}
                className="absolute inset-0 flex items-center justify-center bg-black/10 transition-colors hover:bg-black/20"
                title={`Play ${label}`}
                aria-label={`Play ${label}`}
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-gray-800 shadow-sm">
                  <PlayIcon />
                </span>
              </button>
            ) : null}
          </>
        ) : (
          <div className="flex h-full w-full items-center justify-center rounded-xl bg-gray-100 text-gray-400">
            {variant === 'video' ? (
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-gray-700 shadow-sm">
                <PlayIcon />
              </span>
            ) : (
              <ImagePlaceholderIcon />
            )}
          </div>
        )}
        {loading ? <PreviewLoadingOverlay label={loadingLabel} /> : null}
      </div>
      <p className="mt-1 text-center text-sm font-semibold text-gray-700">{label}</p>
    </div>
  );
}

const FlythroughExportVideoPanel = ({
  showFlythroughExportVideoPanel = false,
  flythroughExportVideoPanelCollapsed = false,
  setFlythroughExportVideoPanelCollapsed,
  metadata = {},
  previewVideoSrc = '',
  thumbnailSrc = '',
  generatedVideoSrc = '',
  generatedThumbnailSrc = '',
  onSaveToLibrary,
  saveToLibraryLoading = false,
  saveToLibraryDisabled = false,
  onDeleteGenerated,
  onDownloadVideo,
  downloadVideoLoading = false,
  onPreviewVideo,
  onPreviewThumbnail,
  onGenerateVideo,
  onCancel,
  generateVideoLoading = false,
  generateStatusLabel = '',
  generateVideoAtCapacity = false,
  previewVideoLoading = false,
  previewStatusLabel = '',
  previewVideoDisabled = false,
  previewVideoDisabledTitle = '',
}) => {
  const [previewVideoModalOpen, setPreviewVideoModalOpen] = useState(false);
  const [renderOutputModalOpen, setRenderOutputModalOpen] = useState(false);

  useEffect(() => {
    if (!previewVideoSrc?.trim()) {
      setPreviewVideoModalOpen(false);
    }
  }, [previewVideoSrc]);

  useEffect(() => {
    if (!generatedVideoSrc?.trim()) {
      setRenderOutputModalOpen(false);
    }
  }, [generatedVideoSrc]);

  if (!showFlythroughExportVideoPanel) return null;

  const hasGeneratedOutput = Boolean(generatedVideoSrc?.trim());
  const generatedPosterSrc = generatedThumbnailSrc?.trim() || generatedVideoSrc?.trim() || '';
  const hasPreviewOutput = Boolean(previewVideoSrc?.trim());
  const showPreviewOutput = previewVideoLoading || hasPreviewOutput;
  const busy = generateVideoLoading || previewVideoLoading;
  const generateDisabled = busy || generateVideoAtCapacity;
  const previewDisabled = busy || previewVideoDisabled;
  const canCancel = busy;

  const handlePreviewClick = () => {
    if (previewVideoDisabled) return;
    onPreviewVideo?.();
  };

  const handleDeleteGeneratedClick = () => {
    onDeleteGenerated?.();
  };

  return (
    <div className="flex shrink-0 min-h-0 items-stretch">
      <button
        type="button"
        onClick={() => setFlythroughExportVideoPanelCollapsed?.((value) => !value)}
        className="flex h-12 w-6 shrink-0 flex-col items-center justify-center self-center rounded-l-lg border-r border-gray-200/60 bg-white/35 box-border backdrop-blur-xl backdrop-saturate-150 transition-colors"
        title={
          flythroughExportVideoPanelCollapsed
            ? 'Show export video panel'
            : 'Hide export video panel'
        }
        aria-expanded={!flythroughExportVideoPanelCollapsed}
        aria-label={
          flythroughExportVideoPanelCollapsed
            ? 'Show export video panel'
            : 'Hide export video panel'
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`shrink-0 transition-transform duration-300 ease-out ${flythroughExportVideoPanelCollapsed ? '' : 'rotate-180'}`}
          aria-hidden
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <aside
        className={`shrink-0 min-h-0 overflow-hidden transition-[width] duration-300 ease-in-out motion-reduce:transition-none ${
          flythroughExportVideoPanelCollapsed ? 'w-0 pointer-events-none' : 'w-[16rem]'
        }`}
        aria-label="Export Video"
      >
        <div className="flex h-full min-h-0 w-[16] min-w-[16rem] flex-col border-l border-gray-200 border-white/50 bg-white/35 px-2 py-4 box-border backdrop-blur-xl backdrop-saturate-150">
          <div className="mb-3 shrink-0 text-center">
            <h3 className="text-[16px] lao-mn text-gray-700">Export Video</h3>
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain pr-0.5">
            <div className="flex flex-col gap-3">
              {showPreviewOutput ? (
                <>
                  <PreviewMediaCard
                    label="Preview Video"
                    src={previewVideoSrc}
                    variant="video"
                    loading={previewVideoLoading}
                    loadingLabel={previewStatusLabel}
                    onPlay={() => setPreviewVideoModalOpen(true)}
                  />
                  <PreviewMediaCard
                    label="Thumbnail"
                    src={thumbnailSrc}
                    videoFallbackSrc={thumbnailSrc?.trim() ? '' : previewVideoSrc}
                    variant="image"
                    loading={previewVideoLoading}
                    loadingLabel={previewStatusLabel}
                    onPlay={onPreviewThumbnail}
                  />
                </>
              ) : null}

              <dl className="shrink-0 space-y-2 px-0.5 text-[11px]">
                {METADATA_ROWS.map(({ label, key }) => (
                  <div key={key} className="flex items-start justify-between gap-3">
                    <dt className="shrink-0 font-medium text-gray-600">{label}</dt>
                    <dd className="min-w-0 text-right text-gray-500">
                      {metadata[key] || '—'}
                    </dd>
                  </div>
                ))}
              </dl>

              {hasGeneratedOutput ? (
                <div>
                  <div className="relative flex h-[120px] items-center justify-center overflow-hidden rounded-2xl border border-gray-200 bg-white p-2 shadow-sm">
                    {generatedPosterSrc ? (
                      <>
                        {generatedThumbnailSrc?.trim() ? (
                          <img
                            src={generatedThumbnailSrc}
                            alt="Generated flythrough video"
                            className="h-full w-full rounded-lg object-cover"
                            draggable={false}
                            referrerPolicy="no-referrer"
                          />
                        ) : (
                          <video
                            src={generatedVideoSrc}
                            className="h-full w-full rounded-lg object-cover"
                            muted
                            playsInline
                            preload="metadata"
                          />
                        )}
                        <button
                          type="button"
                          onClick={() => setRenderOutputModalOpen(true)}
                          className="absolute inset-0 flex items-center justify-center bg-black/10 transition-colors hover:bg-black/20"
                          title="View generated video"
                          aria-label="View generated video"
                        >
                          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-gray-800 shadow-sm">
                            <PlayIcon />
                          </span>
                        </button>
                      </>
                    ) : null}
                  </div>
                  <p className="mt-1 text-center text-sm font-semibold text-gray-700">Render output</p>
                </div>
              ) : null}
            </div>
          </div>

          <div className="mt-3 flex shrink-0 flex-col gap-2 pt-2">
            {hasGeneratedOutput ? (
              <>
                <div className="flex gap-2">
                  <button
                    type="button"
                    onClick={onSaveToLibrary}
                    disabled={busy || saveToLibraryLoading || saveToLibraryDisabled}
                    className="flex-1 rounded-full border border-gray-800 bg-gray-800 px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    {saveToLibraryLoading ? 'Saving…' : 'Save to library'}
                  </button>
                  <button
                    type="button"
                    onClick={handleDeleteGeneratedClick}
                    disabled={busy}
                    className="flex-1 rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-red-600 transition-colors hover:border-red-300 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Delete
                  </button>
                </div>

                <button
                  type="button"
                  onClick={onDownloadVideo}
                  disabled={busy || downloadVideoLoading}
                  className={`${actionButtonClass} w-full`}
                >
                  {downloadVideoLoading ? 'Downloading…' : 'Download Video'}
                </button>
              </>
            ) : null}

            <div className="flex gap-2">
              <span
                className="flex min-w-0 flex-1"
                title={
                  previewVideoDisabled && !busy && previewVideoDisabledTitle
                    ? previewVideoDisabledTitle
                    : undefined
                }
              >
                <button
                  type="button"
                  onClick={handlePreviewClick}
                  disabled={previewDisabled}
                  className={`${actionButtonClass} w-full`}
                >
                  <PreviewButtonIcon />
                  {previewVideoLoading
                    ? previewStatusLabel
                      ? (
                          <span className="capitalize">{previewStatusLabel}</span>
                        )
                      : 'Previewing…'
                    : 'Preview'}
                </button>
              </span>
              <button
                type="button"
                onClick={onPreviewThumbnail}
                disabled={busy}
                className={`${actionButtonClass} flex-1`}
              >
                <ThumbnailButtonIcon />
                Thumbnail
              </button>
            </div>

            <div className="flex gap-2">
              <button
                type="button"
                onClick={onGenerateVideo}
                disabled={generateDisabled}
                className={`${actionButtonClass} flex-1`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  className="shrink-0"
                  aria-hidden
                >
                  <path
                    d="M9.64036 2.62525C9.57656 2.51143 9.4836 2.41667 9.37102 2.35072C9.25845 2.28477 9.13033 2.25 8.99986 2.25C8.86938 2.25 8.74127 2.28477 8.62869 2.35072C8.51612 2.41667 8.42315 2.51143 8.35936 2.62525C8.20936 2.89825 8.06511 3.17475 7.92661 3.45475C7.49025 4.34046 7.11926 5.25691 6.81661 6.19675C6.71236 6.52 6.40336 6.74425 6.04936 6.754C4.97627 6.78221 3.90668 6.88874 2.84911 7.07275C2.26861 7.17475 2.05036 7.83625 2.46286 8.23975C2.55686 8.33225 2.65186 8.4235 2.74786 8.5135C3.46565 9.19139 4.2246 9.82434 5.02036 10.4087C5.29561 10.6105 5.40886 10.9562 5.30386 11.2727C4.90388 12.475 4.61762 13.7122 4.44886 14.968C4.37386 15.5342 4.97986 15.934 5.50636 15.664C6.55039 15.1287 7.54874 14.5086 8.49136 13.81C8.639 13.7022 8.81707 13.6442 8.99986 13.6442C9.18265 13.6442 9.36071 13.7022 9.50836 13.81C10.4508 14.5089 11.4492 15.129 12.4934 15.664C13.0191 15.934 13.6259 15.5342 13.5509 14.968C13.5219 14.7555 13.4901 14.5442 13.4556 14.3342C13.2823 13.2955 13.0283 12.2719 12.6959 11.2727C12.5909 10.9562 12.7034 10.6105 12.9794 10.4087C13.8822 9.74724 14.7368 9.02241 15.5369 8.23975C15.9494 7.83625 15.7319 7.17475 15.1506 7.07275C14.0932 6.88767 13.0235 6.78113 11.9504 6.754C11.7807 6.7513 11.616 6.69634 11.4787 6.59662C11.3414 6.4969 11.2382 6.35726 11.1831 6.19675C10.7846 4.95975 10.268 3.76324 9.64036 2.62525Z"
                    stroke="currentColor"
                    strokeWidth="1.125"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {generateVideoLoading
                  ? generateStatusLabel
                    ? (
                        <span className="capitalize">{generateStatusLabel}</span>
                      )
                    : 'Generating…'
                  : 'Generate'}
              </button>
              <button
                type="button"
                onClick={onCancel}
                disabled={!canCancel}
                className={`${actionButtonClass} flex-1`}
              >
                <svg
                  className="h-4 w-4 shrink-0"
                  viewBox="0 0 14 14"
                  fill="none"
                  stroke="currentColor"
                  aria-hidden
                >
                  <path
                    d="M8.5625 8.5625L4.5625 4.5625M8.5625 4.5625L4.5625 8.5625M6.5625 12.5625C5.77457 12.5625 4.99435 12.4073 4.2664 12.1058C3.53844 11.8043 2.87701 11.3623 2.31986 10.8051C1.76271 10.248 1.32075 9.58655 1.01922 8.8586C0.717693 8.13065 0.562499 7.35043 0.562499 6.5625C0.562499 5.77457 0.717693 4.99435 1.01922 4.2664C1.32075 3.53845 1.76271 2.87701 2.31986 2.31986C2.87701 1.76271 3.53844 1.32075 4.2664 1.01922C4.99435 0.717694 5.77457 0.5625 6.5625 0.5625C8.1538 0.5625 9.67992 1.19464 10.8051 2.31986C11.9304 3.44508 12.5625 4.9712 12.5625 6.5625C12.5625 8.1538 11.9304 9.67992 10.8051 10.8051C9.67992 11.9304 8.1538 12.5625 6.5625 12.5625Z"
                    strokeWidth="1.125"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </aside>

      <RenderPreviewModal
        open={previewVideoModalOpen && Boolean(previewVideoSrc?.trim())}
        src={previewVideoSrc}
        onClose={() => setPreviewVideoModalOpen(false)}
        ariaLabel="Preview video"
        alt="Preview video"
        mediaType="video"
      />
      <RenderPreviewModal
        open={renderOutputModalOpen && hasGeneratedOutput}
        src={generatedVideoSrc}
        onClose={() => setRenderOutputModalOpen(false)}
        ariaLabel="Generated flythrough video"
        alt="Generated flythrough video"
        mediaType="video"
      />
    </div>
  );
};

export default FlythroughExportVideoPanel;
